import { connect } from "react-redux";
import Total from "./Total";
import { getStoreCode } from "../../../../state/modules/regionalStore";
import { getGrandTotalPriceText } from "../../../../state/modules/bag";

const mapStateToProps = state => ({
  storeCode: getStoreCode(state),
  text: getGrandTotalPriceText(state)
});

export default connect(mapStateToProps)(Total);
